/** Session-only dismiss / bookmark (not persisted to server). */

const dismissKey = (conn: string | null) => `fd-ops-dismissed:${conn ?? 'none'}`;
const bookmarkKey = (conn: string | null) => `fd-ops-bookmarked:${conn ?? 'none'}`;

function readSet(key: string): Set<string> {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return new Set();
    const arr = JSON.parse(raw) as unknown;
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.filter((x): x is string => typeof x === 'string'));
  } catch {
    return new Set();
  }
}

function writeSet(key: string, set: Set<string>) {
  try {
    sessionStorage.setItem(key, JSON.stringify([...set]));
  } catch {
    /* private mode */
  }
}

export function loadDismissed(connectionId: string | null): Set<string> {
  return readSet(dismissKey(connectionId));
}

export function loadBookmarked(connectionId: string | null): Set<string> {
  return readSet(bookmarkKey(connectionId));
}

export function saveDismissed(connectionId: string | null, set: Set<string>) {
  writeSet(dismissKey(connectionId), set);
}

export function saveBookmarked(connectionId: string | null, set: Set<string>) {
  writeSet(bookmarkKey(connectionId), set);
}
